import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_QUANTITY_Interface, QUANTITY_Interface } from 'src/app/Interface/QUANTITY_Interface';
import { Empty_Unit_Interface, Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { QUANTITYService } from 'src/app/Service/QUANTITY/QUANTITY.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';

@Component({
  selector: 'app-UnitAdd',
  templateUrl: './UnitAdd.component.html',
  styleUrls: ['./UnitAdd.component.css']
})
export class UnitAddComponent implements OnInit {

  Token: String = ""

  constructor(
    private Unit_Service: UnitService,
    private Nav_Service: NavService,
    private Quantity_Service: QUANTITYService,
    private modalService: BsModalService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.AddNewUnit = new FormGroup({
      id: new FormControl(),
      Title: new FormControl(null, Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token, 48).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }




  //#region  Form Add

  AddNewUnit: FormGroup;

  get_Form_Title() {
    return this.AddNewUnit.get('Title') as FormControl;
  }

  //#endregion

  InProccessing: boolean = false

  SubmitAddNewUnit() {
    var Record: Unit_Interface = Empty_Unit_Interface()
    Record.id = 0
    Record.title = this.get_Form_Title().value
    Record.quantity_id = this.Data_Seleted_Record.id
    this.InProccessing = true
    this.Unit_Service.AddUnit(Record, this.Token).subscribe(
      data => {
        this.InProccessing = false
        if (data.id == -2) {
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
        }
        else {
          this.AddNewUnit.reset()
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }



  //#region Measurement quantity

  modalRef_QUANTITY: any;
  page: number = 0

  ProcssingQUANTITY: boolean = false

  Search_Name_QUANTITY_Table: string = ''

  openModal_QUANTITY(template: TemplateRef<any>) {
    this.modalRef_QUANTITY = this.modalService.show(template);
  }

  DataList_QUANTITY: Array<QUANTITY_Interface> = []
  Data_Seleted_Record: QUANTITY_Interface = Empty_QUANTITY_Interface()



  ReadData_QUANTITY() {
    this.ProcssingQUANTITY = true
    this.Quantity_Service.GetActiveParent(this.Token).subscribe(
      data => {
        this.DataList_QUANTITY = data
        this.ProcssingQUANTITY = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Set_Selected_QUANTITY_Record(item) {
    this.Data_Seleted_Record = item
    this.modalRef_QUANTITY.hide()
  }

  //#endregion




}
